import { user } from '@/store/modules/user'
import { ui } from '@/store/modules/ui'
import { checkout } from '@/store/modules/checkout'
import { listing } from '@/store/modules/listing'
import { product } from '@/store/modules/product'
import { category } from '@/store/modules/category'
import { cart } from '@/store/modules/cart'
import { cms } from '@/store/modules/cms'
import { orders } from '@/store/modules/orders'
import { giftCard } from '@/store/modules/giftCard'
import { storeConfig } from '@/store/modules/storeConfig'
import { storeLocator } from './modules/storeLocator'

import userStore from '@/store/modules/user/store'
import cartStore from '@/store/modules/cart/store'
import uiStore from '@/store/modules/ui/store'
import checkoutStore from '@/store/modules/checkout/store'

import userAdminStore from './modules/userAdmin/store'

import extendListing from './modules/listing'
import extendUser from './modules/user'
import extendUi from './modules/ui'
import extendCategory from './modules/category'
import extendProduct from './modules/product'
import extendStoreConfig from './modules/storeConfig'
import extendOrders from './modules/orders'
import extendCart from './modules/cart'
import extendCheckout from './modules/checkout'
import { quickBuy } from './modules/quickBuy'
import { search } from './modules/search'
import { userAdmin } from './modules/userAdmin'

export default () => {
  return {
    modules: {
      user: extendUser(user()),
      ui: extendUi(ui()),
      checkout: extendCheckout(checkout()),
      listing: extendListing(listing()),
      product: extendProduct(product()),
      category: extendCategory(category()),
      cart: extendCart(cart()),
      cms: cms(),
      orders: extendOrders(orders()),
      giftCard: giftCard(),
      storeLocator: storeLocator(),
      storeConfig: extendStoreConfig(storeConfig()),
      quickBuy: quickBuy(),
      search: search(),
      userAdmin: userAdmin()
    },
    plugins: [
      userStore,
      cartStore,
      uiStore,
      checkoutStore,
      userAdminStore
    ]
  }
}
